import React, { useEffect, useRef, useState, useCallback } from "react";

const getBracket = (width) => {
	if (width < 480) return 0;
	if (width < 640) return 1;
	if (width < 1024) return 2;
	if (width < 1280) return 3;
	if (width < 1440) return 4;
	if (width < 1920) return 5;
	if (width < 2400) return 6;
	if (width < 2880) return 7;
	return 8;
};

export default function Image({ src = [], width, height, alt }) {
	const [loadImage, setLoadImage] = useState(false);
	const [loaded, setLoaded] = useState(false);
	const [bracket, setBracket] = useState(0);

	const boxRef = useRef(null);
	const imageRef = useRef(null);
	const observerRef = useRef(null);

	const updateBracket = useCallback(() => {
		if (boxRef.current) {
			const newWidth = boxRef.current.clientWidth * window.devicePixelRatio;
			const newBracket = getBracket(newWidth);
			if (newBracket !== bracket) {
				setBracket(newBracket);
			}
		}
	}, [bracket]);

	const handleIntersection = useCallback((entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting && !loadImage) {
				setLoadImage(true);
			}
		}
	}, [loadImage]);

	const loadComplete = () => {
		if (imageRef.current?.complete) {
			setLoaded(true);
		}
	};

	useEffect(() => {
		if (!boxRef.current) return;

		observerRef.current = new IntersectionObserver(handleIntersection, {
			root: null,
			rootMargin: "0px 0px 100% 0px",
			threshold: 0,
		});
		observerRef.current.observe(boxRef.current);

		updateBracket();
		window.addEventListener("resize", updateBracket);

		return () => {
			window.removeEventListener("resize", updateBracket);
			if (observerRef.current) observerRef.current.disconnect();
		};
	}, [handleIntersection, updateBracket]);

	useEffect(() => {
		loadComplete();
	}, [bracket]);

	if (!Array.isArray(src) || !src[bracket]) return null;

	const altText = alt || '';
	const loadedClass = loaded ? "state-media-loaded" : "";
	const wrapperStyle = width && height ? { paddingTop: `${(height / width) * 100}%` } : null;

	//const targetSrc = (src[bracket] + '.webp').replace('.webp.webp', '.webp');
	const targetSrc = (src[bracket]);

	return (
		<div
			className={`c-media ${width && height ? "" : "c-media--fill"} ${loaded ? "state-loaded" : ""}`}
			ref={boxRef}
			style={wrapperStyle}
		>
			{loadImage && (
				<img
					ref={imageRef}
					onLoad={loadComplete}
					alt={altText}
					src={targetSrc}
				/>
			)}
		</div>
	);
}
